import React from 'react';
import PropTypes from 'prop-types';
import classnames from 'classnames';
import 'reset-css/reset.css';
import '../color/color';
import '../interactions/interactions';
import '../typography/typography';
import css from './navigation-link.css';

const NavigationLink = ({
  text,
  secondary,
  major,
  minor,
  inverse,
  selected,
  className,
  ...otherProps
}) => (
  <a
    className={classnames(className, css['ds-navigation-link'], {
      [css['ds-navigation-link--secondary']]: secondary,
      [css['ds-navigation-link--major']]: major,
      [css['ds-navigation-link--minor']]: minor,
      [css['ds-navigation-link--inverse']]: inverse,
      [css['ds-navigation-link--selected']]: selected,
    })}
    {...otherProps}
  >
    <span>{text}</span>
  </a>
);

NavigationLink.defaultProps = {
  className: null,
  text: '',
  secondary: false,
  major: false,
  minor: false,
  inverse: false,
  selected: false,
};

NavigationLink.propTypes = {
  className: PropTypes.string,
  text: PropTypes.string,
  secondary: PropTypes.bool,
  major: PropTypes.bool,
  minor: PropTypes.bool,
  inverse: PropTypes.bool,
  selected: PropTypes.bool,
};

export default NavigationLink;
